import _slicedToArray from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { spacer12 } from '@spotify-internal/encore-web';
import { failure, success } from '@mrkt/features/encore-legacy-tokens';
import { EMPTY_IMAGE } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Overlay = styled.div.withConfig({
  displayName: "AssetDebugFrame__Overlay",
  componentId: "sc-1lj5sfw-0"
})(["position:absolute;top:0;left:0;right:0;bottom:0;z-index:1000;background-color:rgba( 255,255,255,", " );color:", ";padding:", ";border:3px dashed ", ";text-align:left;overflow:auto;ul{li{list-style:disc;margin-bottom:", ";}}"], function (props) {
  return props.hasErrors ? 0.8 : 0;
}, failure, spacer12, function (props) {
  return props.hasErrors ? failure : success;
}, spacer12);
export var AssetDebugFrame = function AssetDebugFrame(_ref) {
  var pictureRef = _ref.pictureRef,
      asset = _ref.asset,
      constraints = _ref.constraints,
      children = _ref.children;
  var errors = useConstraintChecks(pictureRef, asset, constraints);

  if (errors !== null && errors !== void 0 && errors.length) {
    // eslint-disable-next-line no-console
    console.warn('Constraints on asset:', asset.title, [''].concat(_toConsumableArray(errors)).join('\n --> '), asset);
  }

  var hasErrors = Boolean(errors === null || errors === void 0 ? void 0 : errors.length);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, /*#__PURE__*/_jsx(Overlay, {
      hasErrors: hasErrors,
      children: /*#__PURE__*/_jsx("ul", {
        children: errors.map(function (err) {
          return /*#__PURE__*/_jsx("li", {
            children: err
          }, err);
        })
      })
    })]
  });
};
export function useConstraintChecks(pictureRef, asset, constraints) {
  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      errors_ = _React$useState2[0],
      setErrors = _React$useState2[1];

  React.useEffect(function () {
    var _asset$file, _constraints$descript;

    var errors = [];
    var currentSrc = getCurrentSrc(pictureRef);
    var isPlaceholder = (currentSrc || '').indexOf('h=10&w=12') > -1 || currentSrc === EMPTY_IMAGE;
    var assetWidth = asset.file.details.image.width;
    var assetHeight = asset.file.details.image.height;
    var aw = 0;
    var ah = 0;

    if (assetWidth && assetHeight && constraints.aspectRatio) {
      var _constraints$aspectRa = _slicedToArray(constraints.aspectRatio, 2);

      aw = _constraints$aspectRa[0];
      ah = _constraints$aspectRa[1];
    } else {
      var _pictureRef$current;

      var aspectBox = (_pictureRef$current = pictureRef.current) === null || _pictureRef$current === void 0 ? void 0 : _pictureRef$current.closest('[data-aspect-ratio]');

      if (aspectBox) {
        var _split$map = aspectBox.getAttribute('data-aspect-ratio').split('x').map(function (s) {
          return parseInt(s, 10);
        });

        var _split$map2 = _slicedToArray(_split$map, 2);

        aw = _split$map2[0];
        ah = _split$map2[1];
      }
    }

    if (assetWidth && assetHeight && aw && ah && (aw / ah).toFixed(1) !== (assetWidth / assetHeight).toFixed(1)) {
      var ar = gcd(assetWidth, assetHeight);
      errors.push("Incorrect aspect ratio, should be: ".concat(aw, "x").concat(ah, " ") + "(is: ~".concat(assetWidth / ar, "x").concat(assetHeight / ar, ", ") + "full size: ".concat(assetWidth, "x").concat(assetHeight, ")"));
    }

    var defaultTypes = ['image/png', 'image/jpeg'];

    if (constraints.video) {
      if (constraints.video.required) defaultTypes = ['video/mp4'];else defaultTypes.push('video/mp4');
    }

    var ctype = asset === null || asset === void 0 ? void 0 : (_asset$file = asset.file) === null || _asset$file === void 0 ? void 0 : _asset$file.contentType;
    var ctypes = constraints.contentTypes || defaultTypes;

    if (ctype && ctypes && !ctypes.find(function (c) {
      return c === ctype;
    })) {
      errors.push("Invalid content type ".concat(ctype, " - should be one of: ").concat(ctypes.join(', ')));
    }

    var xctypes = constraints.excludeContentTypes;

    if (ctype && xctypes && xctypes.find(function (c) {
      return c === ctype;
    })) {
      errors.push("Invalid content type ".concat(ctype, " - should NOT be one of: ").concat(xctypes.join(', ')));
    }

    var minDim = constraints.minDimensions;

    if (minDim && assetWidth && assetHeight && (assetWidth < minDim[0] || assetHeight < minDim[1])) {
      errors.push("Image too small " + "(is: ".concat(assetWidth, "x").concat(assetHeight, ", ") + "should be at least: ".concat(minDim[0], "x").concat(minDim[1], ")"));
    }

    var maxSize = constraints.maxFileSize || 2000000;
    var fsize = asset.file.details.size;

    if (maxSize && fsize && fsize > maxSize) {
      errors.push("File size is too large @ ".concat(bytesToSize(fsize), " ") + "- should be less than: ".concat(bytesToSize(maxSize), ")"));
    }

    if (!isSafari() && currentSrc && currentSrc.indexOf('fm=webp') === -1 && !isPlaceholder) {
      errors.push("Non-safari browsers should display WebP image - URL is: ".concat(currentSrc));
    }

    if (((_constraints$descript = constraints.description) === null || _constraints$descript === void 0 ? void 0 : _constraints$descript.required) !== false && !asset.description) {
      errors.push("Missing description for alt text");
    }

    setErrors(errors);
  }, []);
  return errors_;
}

function gcd(a, b) {
  return b === 0 ? a : gcd(b, a % b);
}

function bytesToSize(bytes) {
  var byteSize = 1000;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  var i = Math.floor(Math.log(bytes) / Math.log(byteSize));
  if (i === 0) return "".concat(bytes, " ").concat(sizes[i], ")");
  return "".concat((bytes / Math.pow(byteSize, i)).toFixed(1), " ").concat(sizes[i]);
}

function getCurrentSrc(pictureRef) {
  var _pictureRef$current2, _pictureRef$current2$;

  return (_pictureRef$current2 = pictureRef.current) === null || _pictureRef$current2 === void 0 ? void 0 : (_pictureRef$current2$ = _pictureRef$current2.querySelector('img')) === null || _pictureRef$current2$ === void 0 ? void 0 : _pictureRef$current2$.currentSrc;
}

function isSafari() {
  return typeof navigator !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}